import {RolandStructuredObject} from "../RolandStructuredObject.js";

export class ZenSampleData extends RolandStructuredObject {
    constructor(file, data, parent, start, length, description) {
        super(file, data, parent, start, length, description);
        this.propertiesName = "SMPd";
    }
}